import rotate from '../assets/svg/rotate.svg';

export default {
  iconSrc: rotate
};
